module.exports = __webpack_public_path__ + "img/xiao-3.8166d650.png";